import request from '@/utils/request';
import { getToken } from '@/utils/auth';
import ENVIRONMENT from '@/utils/environment';

/**
 *   获取授权码列表
 * @method getAuthorizationCodeList
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getAuthorizationCodeList(params) {
  return request({
    url: `/operate/authorizations/`,
    method: 'get',
    params: params
  });
}

/**
 *   获取机构树
 * @method getOrgTree
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getOrgTree() {
  return request({
    url: `/commons/tree`,
    method: 'get'
  });
}

/**
 *   获取授权码详情
 * @method getAuthorizationCodeDetail
 * @author LiYang
 * @return { request } axsio请求封装
 */
export function getAuthorizationCodeDetail(id) {
  return request({
    url: `/operate/authorizations/${id}`,
    method: 'get'
  });
}

// /**
//  *   导出excel
//  * @method exportAuthorizationCode
//  * @param { string } orgCodes 请求参数
//  * @return { request } axsio请求封装
//  */
// export function exportAuthorizationCode(orgCodes) {
//   return request({
//     url: `/operate/authorizations/export`,
//     method: 'get',
//     params: { orgCodes }
//   });
// }

export function exportAuthorizationCode(orgCodes) {
  // return request({
  //   url: `/operate/authorizations/export`,
  //   method: 'get',
  //   params: { orgCodes }
  // });

  return `${ENVIRONMENT.BASE_API}/operate/authorizations/export?orgCodes=${orgCodes}&token=${getToken()}`;
}

/**
 *   批量生成授权码
 * @method batchAuthorizationCode
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function batchAuthorizationCode(form) {
  return request({
    url: `/operate/authorizations/batch`,
    method: 'post',
    data: form,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 *   禁用/启用授权码
 * @method updateAuthorizationCodeStatus
 * @param  form
 * @return { request } axsio请求封装
 */
export function updateAuthorizationCodeStatus(form) {
  return request({
    url: `/operate/authorizations/update/status`,
    method: 'post',
    data: form,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}
